import { render, staticRenderFns } from "./CreateUserView.vue?vue&type=template&id=58a0c820"
import script from "./CreateUserView.vue?vue&type=script&lang=js"
export * from "./CreateUserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports